import React from 'react';
import { TopBar } from '../components/TopBar';
import { Hero } from '../components/Hero';
import { EmotionalAgitation } from '../components/EmotionalAgitation';
import { SolutionIntro } from '../components/SolutionIntro';
import { TheMethodSixPhases } from '../components/TheMethodSixPhases';
import { WhatsInside } from '../components/WhatsInside';
import { WhoFor } from '../components/WhoFor';
import { SocialProof } from '../components/SocialProof';
import { IdentityQuote } from '../components/IdentityQuote';
import { PricingAnchor } from '../components/PricingAnchor';
import { HowItWorks } from '../components/HowItWorks';
import { FinalCTA } from '../components/FinalCTA';
import { FAQ } from '../components/FAQ';
import { Footer } from '../components/Footer';
export function Landing() {
  return <div className="container" data-id="element-204">
      <TopBar data-id="element-205" />
      <main data-id="element-206">
        <Hero data-id="element-207" />
        <EmotionalAgitation data-id="element-208" />
        <SolutionIntro data-id="element-209" />
        <TheMethodSixPhases data-id="element-210" />
        <WhatsInside data-id="element-211" />
        <WhoFor data-id="element-212" />
        <SocialProof data-id="element-213" />
        <IdentityQuote data-id="element-214" />
        <PricingAnchor data-id="element-215" />
        <HowItWorks data-id="element-216" />
        <FinalCTA data-id="element-217" />
        <FAQ data-id="element-218" />
      </main>
      <Footer data-id="element-219" />
    </div>;
}